import React, {Component} from 'react';
import DialogRow from './DialogRow';
import {renderSignature} from '../shared/imageFunctions';

class DialogLocationLogDetail extends Component {

    render() {
        const {
            data
        } = this.props;

        return (
            <div className="reports-custom-table-container">
                {data.location_id &&
                <DialogRow label="Location" value={data.location_id}/>
                }
                {data.type &&
                <DialogRow label="Type" value={data.type}/>
                }
                {data.date_string &&
                <DialogRow label="Date" value={data.date_string}/>
                }
                {data.register &&
                <DialogRow label="Register" value={data.register}/>
                }
                {data.user &&
                <DialogRow label="User" value={data.user}/>
                }
                {data.device &&
                <DialogRow label="Device" value={data.device}/>
                }
                {data.system &&
                <DialogRow label="System" value={data.system}/>
                }
                {data.source &&
                <DialogRow label="Source" value={data.source}/>
                }
                {data.version &&
                <DialogRow label="Version" value={data.version}/>
                }
                {data.signature &&
                <DialogRow label="Signature" value={renderSignature(data.signature)}/>
                }
            </div>
        );
    }
}

export default DialogLocationLogDetail;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogLocationLogDetail.js